import React from 'react';
import { createIcon } from '@chakra-ui/react';
export var Cross = createIcon({
  displayName: 'CrossIcon',
  path: /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.524 15.756c.488.49.488 1.279 0 1.768-.244.244-.564.366-.884.366-.32 0-.64-.122-.884-.366L12 13.767l-3.756 3.757c-.244.244-.564.366-.884.366-.32 0-.64-.122-.884-.366-.488-.49-.488-1.279 0-1.768L10.233 12 6.476 8.244c-.488-.49-.488-1.279 0-1.768.49-.488 1.279-.488 1.768 0L12 10.233l3.756-3.757c.49-.488 1.279-.488 1.768 0 .488.49.488 1.279 0 1.768L13.767 12l3.757 3.756z",
    transform: "translate(-849 -3337) translate(0 2733) translate(42 526) translate(807 78)"
  }),
  defaultProps: {
    color: 'black.200',
    boxSize: 8
  }
});